import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id D8BFD10F-6D55-4EE1-8D30-5B5CB064CBBF
 * name volume-minus
 * version: 1.9.32
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/volume-minus.svg
 * tags
 * - Audio 
 * - Home Automation 
 * - Cellphone / Phone 
 */
export const VolumeMinusIcon = createSvgIcon(<><path d="M3,9H7L12,4V20L7,15H3V9M14,11H22V13H14V11Z" /></>, 'VolumeMinusIcon');
export default VolumeMinusIcon